import { NextApiRequest } from 'next'
import { NextRequest } from 'next/server'

const stripProtocolAndPort = (url: string): string => {
  return url.replace('https://', '').replace('http://', '').split(':')[0]
}

export const getSubdomain = (request: NextApiRequest | NextRequest): string | null => {
  let origin: string | null | undefined = null
  let host: string | null | undefined = null

  if ('headers' in request) {
    if (typeof request.headers.get === 'function') {
      // NextRequest
      origin = request.headers.get('origin')
      host = request.headers.get('host')
    } else {
      // NextApiRequest
      const headers = request.headers as { origin?: string; host?: string }
      origin = headers.origin
      host = headers.host
    }
  }

  return getSubdomainFromURL(origin ?? host ?? '')
}

export const getSubdomainFromURL = (url: string): string | null => {
  const appDomain = stripProtocolAndPort(process.env.NEXT_PUBLIC_DOMAIN || '')

  if (!url || !appDomain) return null

  const subdomain = stripProtocolAndPort(url).split(':')[0].replace(appDomain, '').replace(/\.$/, '')

  if (url === subdomain || !subdomain) {
    return null
  }

  return subdomain
}
